import CardsContent from "./content/cards-content.jsx";
import IndividualsSex from "./content/individuals-sex.jsx";
import EncounterAge from "./content/encounter-age.jsx";
import IndividualWithMoreEncounters from "./content/individual-with-more-encounters.jsx";
import EncounterVehicleType from "./content/encounter-vehicle-type.jsx";
import EncounterActions from "./content/encounter-actions.jsx";
import EncounterWeekday from "./content/encounter-weekday.jsx";
import EncounterTeam from "./content/encounter-team.jsx";
import EncounterAgents from "./content/encounter-agents.jsx";
import VehiclesIndividualsData from "./content/vehicles-individuals-data.js";

export default function ReportContent({ data, collapsed, boName }) {
    return (
        <>
            <div className="space-y-6">
                <VehiclesIndividualsData data={data} />
                <CardsContent data={data} boName={boName} />
                <IndividualsSex data={data} key={`individualStatusKey-${collapsed}`} />
                <EncounterAge data={data} key={`encounterByAgeKey-${collapsed}`} />
                <IndividualWithMoreEncounters data={data} key={`individualWithMoreEncountersKey-${collapsed}`} />
                <EncounterVehicleType data={data} key={`encounterByVehicleTypeKey-${collapsed}`} />
                <EncounterActions data={data} key={`encounterActionsKey-${collapsed}`} />
                <EncounterWeekday data={data} key={`encounterByWeekdayKey-${collapsed}`} />
                <EncounterTeam data={data} key={`EncounterByTeamKey-${collapsed}`} />
                <EncounterAgents data={data} key={`EncounterByAgentsKey-${collapsed}`} />
            </div>
            <div id="chart-tables" />
        </>
    )
}